import { gql } from '@apollo/client'
import { LOGGED_IN_USER_FRAGMENT } from '../fragments'

export const GET_LOGGED_IN_USER = gql`
  query GetLoggedInUser {
    loggedInUser {
      ...LoggedInUser
    }
  }
  ${LOGGED_IN_USER_FRAGMENT}
`
